/**
 * 教材
 * 教材API
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';
import CompanyBaseVo from './CompanyBaseVo';
import UnitVo from './UnitVo';




  /**
   * The TextBookInfoVo model module.
   * @module textbook/model/TextBookInfoVo
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>TextBookInfoVo</code>.
   * @alias module:textbook/model/TextBookInfoVo
   * @class
   */
  var exports = function() {
    var _this = this;




































  };

  /**
   * Constructs a <code>TextBookInfoVo</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:textbook/model/TextBookInfoVo} obj Optional instance to populate.
   * @return {module:textbook/model/TextBookInfoVo} The populated <code>TextBookInfoVo</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'title')) {
        obj['title'] = ApiClient.convertToType(data['title'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'thumbUrl')) {
        obj['thumbUrl'] = ApiClient.convertToType(data['thumbUrl'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'cardBgUrl')) {
        obj['cardBgUrl'] = ApiClient.convertToType(data['cardBgUrl'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'summary')) {
        obj['summary'] = ApiClient.convertToType(data['summary'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'content')) {
        obj['content'] = ApiClient.convertToType(data['content'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'categoryId')) {
        obj['categoryId'] = ApiClient.convertToType(data['categoryId'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'isbn')) {
        obj['isbn'] = ApiClient.convertToType(data['isbn'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'authors')) {
        obj['authors'] = ApiClient.convertToType(data['authors'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'publishers')) {
        obj['publishers'] = ApiClient.convertToType(data['publishers'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'price')) {
        obj['price'] = ApiClient.convertToType(data['price'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'md5')) {
        obj['md5'] = ApiClient.convertToType(data['md5'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'versionNum')) {
        obj['versionNum'] = ApiClient.convertToType(data['versionNum'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'downloadable')) {
        obj['downloadable'] = ApiClient.convertToType(data['downloadable'], 'Boolean');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'unitList')) {
        obj['unitList'] = ApiClient.convertToType(data['unitList'], [UnitVo]);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'tocExpandLevel')) {
        obj['tocExpandLevel'] = ApiClient.convertToType(data['tocExpandLevel'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'chiefEditor')) {
        obj['chiefEditor'] = ApiClient.convertToType(data['chiefEditor'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'deputyEditor')) {
        obj['deputyEditor'] = ApiClient.convertToType(data['deputyEditor'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'contributingAuthors')) {
        obj['contributingAuthors'] = ApiClient.convertToType(data['contributingAuthors'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'producer')) {
        obj['producer'] = ApiClient.convertToType(data['producer'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'producerCompanyId')) {
        obj['producerCompanyId'] = ApiClient.convertToType(data['producerCompanyId'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'producerCompany')) {
        obj['producerCompany'] = CompanyBaseVo.constructFromObject(data['producerCompany']);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'contactInfo')) {
        obj['contactInfo'] = ApiClient.convertToType(data['contactInfo'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'edition')) {
        obj['edition'] = ApiClient.convertToType(data['edition'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'eduStage')) {
        obj['eduStage'] = ApiClient.convertToType(data['eduStage'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'copyrightStatement')) {
        obj['copyrightStatement'] = ApiClient.convertToType(data['copyrightStatement'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'publisherCompany')) {
        obj['publisherCompany'] = CompanyBaseVo.constructFromObject(data['publisherCompany']);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'bookFormat')) {
        obj['bookFormat'] = ApiClient.convertToType(data['bookFormat'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'pdfFileUri')) {
        obj['pdfFileUri'] = ApiClient.convertToType(data['pdfFileUri'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'pdfFileSize')) {
        obj['pdfFileSize'] = ApiClient.convertToType(data['pdfFileSize'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'hasPdf')) {
        obj['hasPdf'] = ApiClient.convertToType(data['hasPdf'], 'Boolean');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'sortKey')) {
        obj['sortKey'] = ApiClient.convertToType(data['sortKey'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'forSale')) {
        obj['forSale'] = ApiClient.convertToType(data['forSale'], 'Boolean');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'aiTextbook')) {
        obj['aiTextbook'] = ApiClient.convertToType(data['aiTextbook'], 'Boolean');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'standardType')) {
        obj['standardType'] = ApiClient.convertToType(data['standardType'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * id
   * @member {Integer} id
   */
  exports.prototype['id'] = undefined;
  /**
   * 书名
   * @member {String} title
   */
  exports.prototype['title'] = undefined;
  /**
   * 封面
   * @member {String} thumbUrl
   */
  exports.prototype['thumbUrl'] = undefined;
  /**
   * 卡片背景图
   * @member {String} cardBgUrl
   */
  exports.prototype['cardBgUrl'] = undefined;
  /**
   * 简介
   * @member {String} summary
   */
  exports.prototype['summary'] = undefined;
  /**
   * 课程详情模板
   * @member {String} content
   */
  exports.prototype['content'] = undefined;
  /**
   * 课程分类id
   * @member {Integer} categoryId
   */
  exports.prototype['categoryId'] = undefined;
  /**
   * ISBN号
   * @member {String} isbn
   */
  exports.prototype['isbn'] = undefined;
  /**
   * 作者名，逗号分隔
   * @member {String} authors
   */
  exports.prototype['authors'] = undefined;
  /**
   * 出版社，逗号分隔
   * @member {String} publishers
   */
  exports.prototype['publishers'] = undefined;
  /**
   * 价格 单位分
   * @member {Integer} price
   */
  exports.prototype['price'] = undefined;
  /**
   * 压缩包md5
   * @member {String} md5
   */
  exports.prototype['md5'] = undefined;
  /**
   * 版本号
   * @member {String} versionNum
   */
  exports.prototype['versionNum'] = undefined;
  /**
   * 是否可下载离线观看
   * @member {Boolean} downloadable
   */
  exports.prototype['downloadable'] = undefined;
  /**
   * @member {Array.<module:textbook/model/UnitVo>} unitList
   */
  exports.prototype['unitList'] = undefined;
  /**
   * 目录展开到第几级，老教材2级，新教材3级
   * @member {Integer} tocExpandLevel
   */
  exports.prototype['tocExpandLevel'] = undefined;
  /**
   * 主编
   * @member {String} chiefEditor
   */
  exports.prototype['chiefEditor'] = undefined;
  /**
   * 副主编
   * @member {String} deputyEditor
   */
  exports.prototype['deputyEditor'] = undefined;
  /**
   * 参编人员
   * @member {String} contributingAuthors
   */
  exports.prototype['contributingAuthors'] = undefined;
  /**
   * 制作单位
   * @member {String} producer
   */
  exports.prototype['producer'] = undefined;
  /**
   * 制作单位id
   * @member {Integer} producerCompanyId
   */
  exports.prototype['producerCompanyId'] = undefined;
  /**
   * 制作单位
   * @member {module:textbook/model/CompanyBaseVo} producerCompany
   */
  exports.prototype['producerCompany'] = undefined;
  /**
   * 教材联系
   * @member {String} contactInfo
   */
  exports.prototype['contactInfo'] = undefined;
  /**
   * 版次
   * @member {String} edition
   */
  exports.prototype['edition'] = undefined;
  /**
   * 1中职，2高职，3 中高职
   * @member {Integer} eduStage
   */
  exports.prototype['eduStage'] = undefined;
  /**
   * 版权声明
   * @member {String} copyrightStatement
   */
  exports.prototype['copyrightStatement'] = undefined;
  /**
   * 出版社
   * @member {module:textbook/model/CompanyBaseVo} publisherCompany
   */
  exports.prototype['publisherCompany'] = undefined;
  /**
   * 电子书格式 0:App 100:自建H5 101:第三方H5 200:pdf
   * @member {Integer} bookFormat
   */
  exports.prototype['bookFormat'] = undefined;
  /**
   * PDF文件存储路径（bookType=2时使用）
   * @member {String} pdfFileUri
   */
  exports.prototype['pdfFileUri'] = undefined;
  /**
   * PDF文件大小（字节）
   * @member {Integer} pdfFileSize
   */
  exports.prototype['pdfFileSize'] = undefined;
  /**
   * 是否有PDF文件（bookType=2时有效）
   * @member {Boolean} hasPdf
   */
  exports.prototype['hasPdf'] = undefined;
  /**
   * 排序键（数字越小越靠前）
   * @member {Integer} sortKey
   */
  exports.prototype['sortKey'] = undefined;
  /**
   * 是否开放销售
   * @member {Boolean} forSale
   */
  exports.prototype['forSale'] = undefined;
  /**
   * 是否AI教材
   * @member {Boolean} aiTextbook
   */
  exports.prototype['aiTextbook'] = undefined;
  /**
   * 规划教材类型 0:无 1:国规 2:省规
   * @member {Integer} standardType
   */
  exports.prototype['standardType'] = undefined;



  export default exports;
;


